module.exports = __webpack_public_path__ + "static/media/valentina.e46895d1.png";